import { render } from "./Register.vue?vue&type=template&id=49571cca&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=49571cca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49571cca"

export default script